import { Component, Input, AfterViewInit, HostListener, ViewChild, ElementRef, TemplateRef, ViewContainerRef, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { HoverPanelService } from './hover-panel.service';
import { UtilityService } from '@irb-common/services/utility.service';

@Component({ standalone: false,
  selector: 'hover-panel',
  templateUrl: './hover-panel.component.html',
  styleUrls: ['./hover-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HoverPanelComponent implements AfterViewInit {
  @ViewChild('hoverPanel') hoverPanel: ElementRef;
  @ViewChild('hoverPanelView') hoverPanelView: ViewContainerRef;
  @Input() template: TemplateRef<any>;
  @Input() ref: ElementRef;
  @Input() position: string;
  defaultPosition: string;
  @Input() event: any;
  @Input() width: string = '300px';
  @Input() height: string = 'auto';
  maxHeight: string = '181px';
  @Input() maxWidth: string = '300px';
  @Input() zIndex: number;
  @Input() onClose: any;
  top: number = 0;
  left: number = 0;
  rect: any;

  constructor(private cdRef:ChangeDetectorRef, private hps: HoverPanelService, private util: UtilityService) { }

  ngAfterViewInit(): void {    
    this.defaultPosition = this.position;
    this.rect = this.hoverPanel.nativeElement.getBoundingClientRect();
    this.redraw();
  }

  redraw() {  
    this.updatePosition(this.event);
  }

  resize() {
    setTimeout(() => {
      this.rect = this.hoverPanel.nativeElement.getBoundingClientRect();
      this.updatePosition(this.event);
    });
  }

  updatePosition(e?: any, positionOverride?: Array<string>) {
    if(typeof e === "undefined") {
      return;
    }

    const positions = (positionOverride) ? [].concat(positionOverride) : ["bottom-left", "bottom-right", "top-left", "top-right"];
    this.position = (positionOverride && positionOverride.length > 0) ? positionOverride.shift() : this.defaultPosition;
    positions.splice(positions.indexOf(this.position),1);
    positionOverride = (positionOverride && positionOverride.length > 0 && positionOverride.indexOf(this.position) === -1) ? positionOverride : positions;

    let t, l, b, r, w, h;
    w = this.rect.right - this.rect.left;
    h = this.rect.bottom - this.rect.top;
    const targetRect = e.target.getBoundingClientRect();
    
    switch(this.position) {
      case "top-left":
        t = targetRect.top - h;
        l = targetRect.left;
        b = t + h;
        r = l + w;

        this.top = t;
        this.left = l;
        break;
      case "bottom-left":
        t = targetRect.top + (e.target.offsetHeight);
        l = targetRect.left;
        b = t + h;
        r = l + w;

        this.top = t;
        this.left = l;
        break;
      case "top-right":
        t = targetRect.top - h;
        l = targetRect.right - w;
        b = t + h;
        r = l + w;

        this.top = t;
        this.left = l;
        break;
      case "bottom-right":
        t = targetRect.top + (e.target.offsetHeight);
        l = targetRect.right - w;
        b = t + h;
        r = l + w;

        this.top = t;
        this.left = l;
        break;
    }

    if(positionOverride.length !== 0 || positionOverride.length === 0 && (this.position !== this.defaultPosition)) {
      if((t < 0) || (b > window.innerHeight) || (l < 0) || (r > window.innerWidth)) {
        this.updatePosition(e, positionOverride);
        return;
      }
    }

    this.cdRef.detectChanges();
  }

  @HostListener('window:mousedown', ['$event'])
  onClick(e: any): void {
    if(!this.hoverPanel.nativeElement.contains(e.target) && e.target !== this.ref.nativeElement) {
      this.hps.remove();
      this.onClose.emit(null);
    }
  }
}
